import { frontendURL } from '../../../helper/URLHelper';
import CalendarIndex from './pages/CalendarIndex.vue';
import RemindersIndex from './pages/RemindersIndex.vue';

const commonMeta = {
  permissions: ['administrator', 'agent', 'calendar_reminders_manage'],
  dotchatModule: 'calendar_reminders',
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/calendar'),
    component: CalendarIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'calendar_index',
        component: CalendarIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/reminders'),
    component: RemindersIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'reminders_index',
        component: RemindersIndex,
        meta: commonMeta,
      },
    ],
  },
];
